export default {
	title: 'L\'Assurance Maladie me prend en charge',
	majCarteVitale: {
		subTitle: 'Je pense à mettre à jour ma carte Vitale :',
		listeMaj: [
			{
				text: '<span class="font-weight-medium">Après avoir réalisé ma déclaration de grossesse</span>, afin que les examens prénataux soient pris en charge à 100%*.'
			},
			{
				text: '<span class="font-weight-medium">&Agrave; mon 6<sup>ème</sup> mois</span> pour que l’ensemble de mes dépenses de santé soient prises en charge à 100%*.'
			}
		]
	},
	carousel: [
		{
			title: 'Mes consultations',
			icon: 'doctor-stethoscope.svg',
			text: 'Les consultations médicales prénatales obligatoires et les examens biologiques complémentaires nécessaires sont remboursés à 100%*.'
		},
		{
			title: 'Mes échographies',
			icon: 'pregnant.svg',
			text: '<p>Les 2 premières échographies sont remboursées à 70%*.</p><p>La 3<sup>ème</sup> échographie est prise en charge à 100%*.</p>'
		},
		{
			title: 'Ma préparation',
			icon: 'briefcase.svg',
			text: 'Les 8 séances de préparation à la naissance et à la parentalité sont remboursées à 100%*.'
		},
		{
			title: 'Mes frais de santé',
			icon: 'coins.svg',
			text: 'A partir du 6<sup>ème</sup> mois de grossesse et jusqu’à 12 jours après l’accouchement, vos dépenses de santé sont prises en charge à 100%*.**'
		},
		{
			title: 'Autres examens',
			icon: 'list.svg',
			text: 'En fonction de votre état de santé, le professionnel de santé qui vous suit peut être amené à vous prescrire d’autres examens de suivi.'
		}
	],
	renvoi: '* Dans la limite des tarifs de remboursement de l\'Assurance Maladie',
	rembousement: '** Vous ne payez plus la participation forfaitaire de 1€, la franchise médicale  et le forfait pour les  actes médicaux lourds et le forfait hospitalier.'
};
